import {
  ORG_LIST,
  EQP_LIST,
  NON_FIRE_EQP_LIST,
  TRAIN_NON_FIRE_RATIO,
} from "./constants";
import { createEmptyRow } from "./rowUtils";

function pickOrg(index, distribution) {
  if (distribution === "weighted") {
    const pool = ORG_LIST.slice(0, Math.min(6, ORG_LIST.length));
    return pool[Math.floor(Math.random() * pool.length)];
  }
  return ORG_LIST[index % ORG_LIST.length];
}

function fillPhoneFields(phoneMode, index) {
  if (phoneMode !== "random") {
    return { pnum: "", name: "" };
  }
  const r1 = String(Math.floor(Math.random() * 9000) + 1000);
  const r2 = String(Math.floor(Math.random() * 9000) + 1000);
  return {
    pnum: `000-${r1}-${r2}`,
    name: `훈련대원${index + 1}`,
  };
}

function orgShortName(org) {
  return org
    .replace("소방재난본부", "")
    .replace("소방안전본부", "")
    .replace("소방본부", "");
}

function buildFireRow(index, { org, rdvName, phoneMode }) {
  const eqp = EQP_LIST[index % EQP_LIST.length];
  const short = orgShortName(org);
  const { pnum, name } = fillPhoneFields(phoneMode, index);
  const remark =
    index === 4 ? "장비점검 필요" : index === 2 ? "" : "훈련용";

  return createEmptyRow(index + 1, {
    sido: org,
    fireStation: `${short}소방서`,
    safetyCenter: `${index + 1}안전센터`,
    eqp,
    callsgn: `${eqp}${index + 1}호`,
    plateNo: `${String.fromCharCode(65 + (index % 26))}${String(1000 + index).slice(1)}가${String(1000 + index)}`,
    sumnum: String(2 + (index % 3)),
    name,
    pnum,
    rdvs: rdvName,
    remark,
  });
}

function buildNonFireRow(index, { org, eqp, rdvName, phoneMode, slot }) {
  const short = orgShortName(org);
  const { pnum, name } = fillPhoneFields(phoneMode, index);
  const presets = {
    소방의소대: {
      fireStation: `${short}의용소방대`,
      safetyCenter: "",
      callsgn: `의소대${slot + 1}`,
      sumnum: String(5 + (slot % 8)),
      remark: "훈련용(의소대)",
    },
    "경찰(인원)": {
      fireStation: "경찰지원",
      safetyCenter: "",
      callsgn: `경찰팀${slot + 1}`,
      sumnum: String(3 + (slot % 6)),
      remark: "훈련용(경찰)",
    },
    "군(인원)": {
      fireStation: "군지원",
      safetyCenter: "",
      callsgn: `군팀${slot + 1}`,
      sumnum: String(4 + (slot % 5)),
      remark: "훈련용(군)",
    },
    "공무원(인원)": {
      fireStation: "공무원지원",
      safetyCenter: "",
      callsgn: `공무원팀${slot + 1}`,
      sumnum: String(2 + (slot % 4)),
      remark: "훈련용(공무원)",
    },
  };
  const preset = presets[eqp] || presets["소방의소대"];

  return createEmptyRow(index + 1, {
    sido: org,
    fireStation: preset.fireStation,
    safetyCenter: preset.safetyCenter,
    eqp,
    callsgn: preset.callsgn,
    plateNo: "",
    sumnum: preset.sumnum,
    name,
    pnum,
    rdvs: rdvName,
    remark: preset.remark,
  });
}

/** 체크 시 전체 개수의 20%를 비소방 행으로 배치할 인덱스 집합 */
export function pickNonFireIndices(total, includeNonFire) {
  if (!includeNonFire || total <= 0) return new Set();
  const count = Math.round(total * TRAIN_NON_FIRE_RATIO);
  if (count <= 0) return new Set();

  const indices = Array.from({ length: total }, (_, i) => i);
  for (let i = indices.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [indices[i], indices[j]] = [indices[j], indices[i]];
  }
  return new Set(indices.slice(0, Math.min(count, total)));
}

export function generateTrainRows({
  count = 10,
  rdvName = "",
  distribution = "equal",
  phoneMode = "random",
  includeNonFire = false,
}) {
  const n = Math.max(1, Math.min(parseInt(count, 10) || 10, 100));
  const nonFireIndices = pickNonFireIndices(n, includeNonFire);
  let nonFireSlot = 0;

  return Array.from({ length: n }, (_, i) => {
    const org = pickOrg(i, distribution);

    if (nonFireIndices.has(i)) {
      const eqp = NON_FIRE_EQP_LIST[nonFireSlot % NON_FIRE_EQP_LIST.length];
      nonFireSlot += 1;
      return buildNonFireRow(i, {
        org,
        eqp,
        rdvName,
        phoneMode,
        slot: nonFireSlot - 1,
      });
    }

    return buildFireRow(i, { org, rdvName, phoneMode });
  });
}
